import ReactGA from 'react-ga';

export default function register() {
  initGA('UA-144159165-2');
  pageView(window.location.pathname + window.location.search);
}

export function initGA(tracking_id) {
  if (window.location.host.indexOf('localhost') === -1) {
    ReactGA.initialize(tracking_id);
  }
}

export function pageView() {
  if (window.location.host.indexOf('localhost') === -1) {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
}

export function trackEvent(category, action, label) {
  if (window.location.host.indexOf('localhost') === -1) {
    ReactGA.event({
      category: category,
      action: action,
      label: label
    });
  }
}



// WEBPACK FOOTER //
// ./src/util/tracking.js